module.exports = __webpack_public_path__ + "img/news--carousel.2be19f6c.svg";